<div class="input-control">
	<input type="text" class="form-control" placeholder="Zoeken" [(ngModel)]="search" (keyup)="onKey($event)">
	<fa-icon [icon]="['fas', 'search']" size="md"></fa-icon>
</div>